import { render, staticRenderFns } from "./UPCLASClassificationReport.vue?vue&type=template&id=4151b4a8"
import script from "./UPCLASClassificationReport.vue?vue&type=script&lang=js"
export * from "./UPCLASClassificationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports